"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigation = void 0;
const openDatasets = () => {
    const inCurrentTab = () => {
        window.open('my-data/datasets/', '_self');
    };
    const inNewTab = () => {
        window.open('my-data/datasets/', '_blank');
    };
    return { inCurrentTab, inNewTab };
};
const openDatasetPage = (datasetId) => {
    const inCurrentTab = () => {
        window.open(`/my-data/datasets/${datasetId}`, '_self');
    };
    const inNewTab = () => {
        window.open(`/my-data/datasets/${datasetId}`, '_blank');
    };
    return { inCurrentTab, inNewTab };
};
const openSetupPage = () => {
    const inCurrentTab = () => {
        window.open('/setup', '_self');
    };
    const inNewTab = () => {
        window.open('/setup', '_blank');
    };
    return { inCurrentTab, inNewTab };
};
const openCLIPage = () => {
    const inCurrentTab = () => {
        window.open('/cli', '_self');
    };
    const inNewTab = () => {
        window.open('/cli', '_blank');
    };
    return { inCurrentTab, inNewTab };
};
exports.navigation = {
    openDatasets: openDatasets,
    openDatasetPage: openDatasetPage,
    openSetupPage: openSetupPage,
    openCLIPage: openCLIPage,
};
